'use client'

import { useEffect } from 'react'

export function EmbedWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.documentElement.scrollHeight
      window.parent.postMessage({ type: 'AMLAB_IFRAME_RESIZE', height }, '*')
    }

    sendHeight()

    const observer = new ResizeObserver(sendHeight)
    observer.observe(document.body)

    return () => observer.disconnect()
  }, [])

  return <div style={{ overflow: 'hidden' }}>{children}</div>
}
